/* Christian Anchor — storefront interactions (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  var lastFocus = null;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  function showDrawer(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) hideDrawer(openDrawer, true);
    lastFocus = document.activeElement;
    el.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
    openDrawer = el;
    var focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function hideDrawer(el, keepOverlay) {
    el = el || openDrawer;
    if (!el) return;
    el.hidden = true;
    if (!keepOverlay && overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawer = null;
    if (lastFocus && !keepOverlay) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); showDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { hideDrawer(); return; }

    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && window.theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault(); showDrawer($('[data-cart-drawer]')); return;
    }

    if (e.target.closest('[data-search-toggle]')) {
      var bar = $('[data-search-bar]');
      if (bar) { bar.hidden = !bar.hidden; if (!bar.hidden) { var i = bar.querySelector('input[type="search"]'); if (i) i.focus(); } }
      return;
    }

    var rec = e.target.closest('[data-recover-toggle]');
    if (rec) {
      e.preventDefault();
      var login = document.getElementById('login'), recover = document.getElementById('recover');
      if (login && recover) { var showRecover = recover.hidden; recover.hidden = !showRecover; login.hidden = showRecover; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openDrawer) hideDrawer();
      $$('.nav__details[open]').forEach(function (d) { d.removeAttribute('open'); });
      var bar = $('[data-search-bar]'); if (bar && !bar.hidden) bar.hidden = true;
    }
  });

  if (window.location.hash === '#recover') {
    var l = document.getElementById('login'), r = document.getElementById('recover');
    if (l && r) { l.hidden = true; r.hidden = false; }
  }

  /* ---------- Desktop dropdowns: hover + close others ---------- */
  var navDetails = $$('.nav__details');
  navDetails.forEach(function (d) {
    var item = d.parentElement;
    var mq = window.matchMedia('(hover: hover)');
    var closeTimer;
    item.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      d.setAttribute('open', '');
    });
    item.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      closeTimer = setTimeout(function () { d.removeAttribute('open'); }, 250);
    });
    /* With a mouse the hover already opened it, so a click on the label shouldn't close it */
    var summary = d.querySelector('summary');
    if (summary) summary.addEventListener('click', function (e) {
      if (mq.matches && d.open) e.preventDefault();
    });
    d.addEventListener('toggle', function () {
      if (d.open) navDetails.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__details')) navDetails.forEach(function (d) { d.removeAttribute('open'); });
  });

  /* ---------- Sticky header shrink ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Announcement rotator ---------- */
  var ann = $$('.announcement__item');
  if (ann.length) ann[0].classList.add('is-active');
  if (ann.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var idx = 0;
    setInterval(function () {
      ann[idx].classList.remove('is-active');
      idx = (idx + 1) % ann.length;
      ann[idx].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Cart (AJAX) ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function refreshDrawer(open) {
    return fetch(window.theme.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var current = $('[data-cart-drawer]');
        if (fresh && current) {
          var wasOpen = !current.hidden;
          current.innerHTML = fresh.innerHTML;
          if (open && !wasOpen) showDrawer(current);
        }
      });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
        return fetch(window.theme.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (window.theme.cartType === 'page') { window.location.href = window.theme.routes.cart; return; }
        return refreshDrawer(true).then(function () { toast(window.theme.strings.added); });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { toast(err.message); }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); if (!btn.hasAttribute('data-soldout')) btn.disabled = false; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-product-form');
    if (!form) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    var drawer = $('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-loading');
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line-change'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return refreshDrawer(false); })
      .finally(function () { var d = $('[data-cart-drawer]'); if (d) d.classList.remove('is-loading'); });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------- Product page: variants & gallery ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    var gallery = root.querySelector('[data-gallery]');

    function showMedia(id) {
      if (!gallery || !id) return;
      var slide = gallery.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      $$('.product__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (t) showMedia(t.getAttribute('data-thumb'));
      });
    }

    if (!jsonEl || !form) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var variants = data.variants || [];
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceWrap = root.querySelector('[data-product-price] [data-price]');

    function selectedOptions() {
      return $$('fieldset[data-option-index]', form).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      $$('fieldset[data-option-index]', form).forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = opts[i] || '';
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      if (!variant) {
        addBtn.disabled = true; addBtn.setAttribute('data-soldout', '');
        addLabel.textContent = window.theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      if (variant.available) {
        addBtn.disabled = false; addBtn.removeAttribute('data-soldout');
        addLabel.textContent = window.theme.strings.addToCart;
      } else {
        addBtn.disabled = true; addBtn.setAttribute('data-soldout', '');
        addLabel.textContent = window.theme.strings.soldOut;
      }
      if (priceWrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        priceWrap.innerHTML = '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '');
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) update(); });
  });


  /* ---------- Sticky add-to-cart (phones) ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var main = document.querySelector('[data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-sticky-add]');
    var price = bar.querySelector('[data-sticky-price]');
    var mq = window.matchMedia('(max-width: 749px)');
    var obs = new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      var show = hidden && mq.matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    });
    obs.observe(main);
    // Keep in sync with the main button (variant changes, sold out).
    var sync = function () {
      btn.disabled = main.disabled;
      btn.textContent = main.textContent.trim();
      var cur = document.querySelector('[data-product-price] .price__current');
      if (cur && price) price.textContent = cur.textContent;
    };
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true });
    btn.addEventListener('click', function () {
      var hasOptions = document.querySelector('[data-product-form] fieldset[data-option-index]');
      if (hasOptions) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); main.focus({ preventScroll: true }); return; }
      main.click();
    });
  })();

  /* ---------- Collection facets: auto-submit sort ---------- */
  $$('[data-facets]').forEach(function (form) {
    var sort = form.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length && el.querySelector('.card')) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.hidden = true;
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  });

  /* ---------- Address delete confirm ---------- */
  document.addEventListener('submit', function (e) {
    var msg = e.target.getAttribute && e.target.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) e.preventDefault();
  });
  $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var targets = $$('.section__head, .tile, .card, .split, .scripture__inner, .trust__item');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); obs.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) {
      if (t.getBoundingClientRect().top > window.innerHeight) { t.classList.add('reveal'); obs.observe(t); }
    });
  }
})();
